/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { PLAN_HIERARCHY, type planTypes } from '../constants/plans/type-plans'

import { useSections } from './useSection'
import { useProfileUser } from './useUser'

import { getPermissionObject, setPermissions } from '@/Redux/permissionsSlice'
import { myFunctions } from '@/firebase'

export function useCheckStudentPermissions() {
  const profile = useProfileUser()
  const dispatch = useDispatch()

  const isStudent = profile.isStudent
  const courses = useSections('members', false, isStudent)

  useEffect(() => {
    if (!isStudent || !courses.isSuccess) return

    // @ts-ignore
    const teacherIds = courses.sections?.map(course => course.owners?.[0])
    const uniqueTeacherIds = [...new Set(teacherIds)] as string[]

    const checkPermissions = async () => {
      const permissionsObject = await getBestPlanFromTeachers(uniqueTeacherIds)

      if (permissionsObject) {
        dispatch(setPermissions(permissionsObject))
      }
    }

    void checkPermissions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStudent, courses.isSuccess])
}

type PlanType = (typeof planTypes)[keyof typeof planTypes]

interface PlanObject {
  plan: PlanType
  [key: string]: any
}

async function getBestPlanFromTeachers(teacherIds: string[]) {
  try {
    const promises = teacherIds
      .map(async teacherId => {
        const { data } = await myFunctions.checkStudentPermissions({
          teacherId,
        })

        // @ts-ignore
        if (data?.error) {
          console.log(data)

          return null
        }

        return data as PlanObject
      })
      .filter(Boolean)

    const teacherData = await Promise.all(promises)

    if (!teacherData.length) {
      console.log('No teachers found')

      return
    }

    const validTeacherData = teacherData.filter(data => data !== null)

    if (!validTeacherData.length) {
      console.log('No valid teacher data found')

      return
    }

    // Encuentra el mejor plan entre todos los profesores
    const bestPlan = validTeacherData.reduce((best: PlanObject, current: PlanObject) => {
      const currentPlanIndex = PLAN_HIERARCHY.indexOf(current.plan as keyof typeof planTypes)
      const bestPlanIndex = PLAN_HIERARCHY.indexOf(best.plan as keyof typeof planTypes)

      return currentPlanIndex > bestPlanIndex ? current : best
    }, validTeacherData[0])

    const permissionsObject = getPermissionObject(bestPlan)

    return permissionsObject
  } catch (error) {
    console.log('FAILED TO LOAD STUDENT PERMISSIONS', error)

    return null
  }
}
